import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './CategoriesSection.module.scss';
import { cleanName } from '../../../../lib/utils';
import { connect } from 'dva';
import { SIDEBAR_VIEWS, STATES_DATA } from '../../../../lib/constants';
import ChevronRight from '../../../../assets/svg/Feather/ChevronRight';

function CategoriesSection(props) {
  useEffect(() => {
    if (props.scrollPosition) {
      const currentElement = document.getElementById(props.scrollPosition)
      if (currentElement) {
        currentElement.scrollIntoView({ block: 'center', inline: 'nearest' })
      }
    }
  }, [])

  const setStateName = (stateName) => {
    let newStateName = cleanName(stateName)
    if (newStateName.toLowerCase() === 'tac') {
      newStateName = 'total archery challenge'
    }
    return newStateName
  }

  const stateName = setStateName(props.stateName)
  const stateIcon = `${props.assetsUrl}/states/icons/small/${STATES_DATA[props.stateName]?.abbrev.toLowerCase()}.png`

  const toggleSection = (e) => {
    props.dispatch({
      type: 'layers/setSelectedLayerCategory',
      payload: {
        stateName: props.stateName,
        categories: props.categories,
      },
    })

    props.dispatch({
      type: 'app/setSideBarScrollPosition',
      payload: { layers: stateName.replace(' ', '_') },
    })

    props.dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.LayerCategoryList,
    })
  }

  const countLayers = (categories) => {
    let counts = {
      enabledLayers: 0,
      totalLayers: 0,
    };

    categories.forEach((category) => {
      if (category.layers != null) {
        category.layers.forEach((layer) => {
          counts.totalLayers += 1;
          if (layer.control.enabled == 1) {
            counts.enabledLayers += 1;
          }
        });
      }

      if (category.subCategories != null) {
        category.subCategories.forEach((subCat) => {
          if (subCat.layers != null) {
            subCat.layers.forEach((layer) => {
              counts.totalLayers += 1;
              if (layer.control.enabled == 1) {
                counts.enabledLayers += 1;
              }
            });
          }
        });
      }
    });
    return counts;
  };

  let { enabledLayers, totalLayers } = countLayers(props.categories);

  return totalLayers > 0 ? (
    <div id={stateName.replace(' ', '_')} className={styles.categorySection}>
      <div className={styles.categorySectionHeader} onClick={toggleSection}>
        <div className={styles.leftSection}>
          <img
            width={24}
						height={24}
            src={
              stateIcon ||
              'https://image.redbull.com/rbcom/052/2017-06-19/3965fbe6-3488-40f8-88bc-b82eb8d1a230/0100/0/1/pogchamp-twitch.png'
            }
          />
          <div className={styles.categoriesSectionText}>
            <h3>{stateName}</h3>
            <p
              className={styles.enabledLayers}
              style={{ color: enabledLayers > 0 ? '#f37735' : '#8e8e92' }}
            >
              {enabledLayers} of {totalLayers} on
            </p>
          </div>
        </div>
        <div className={styles.rightSection}>
          <div className={`${styles.categoryIndicator} ${enabledLayers > 0 ? styles.categoryActive : styles.categoryInactive}`} />
          <ChevronRight color='#8e8e92' />
        </div>
      </div>
    </div>
  ) : null;
}

CategoriesSection.propTypes = {
  appConfig: PropTypes.object,
  assetsUrl: PropTypes.string,
  categories: PropTypes.array,
  currentUser: PropTypes.object,
  isOpen: PropTypes.bool,
  scrollPosition: PropTypes.string,
  stateName: PropTypes.string
};

export default connect((model) => {
  return {
    appConfig: model.app.config,
    assetsUrl: model.app.config.GH_ASSETS_CLOUDFRONT_URL,
    currentUser: model.user.currentUser,
    scrollPosition: model.app.sideBarScrollPosition.layers
  };
})(CategoriesSection);
